// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/management/address-book2/address-book.component.css
// module id = 492
// module chunks = 0